var map = {
	"./Andy-Hablando": "3aa4",
	"./Andy-Hablando.json": "3aa4",
	"./Andy-logo": "2e5e",
	"./Andy-logo.json": "2e5e",
	"./alexhead_04": "a3bb",
	"./alexhead_04.json": "a3bb",
	"./alexhead_08": "9703",
	"./alexhead_08.json": "9703",
	"./andy": "28b0",
	"./andy.json": "28b0",
	"./sensor": "844f",
	"./sensor-bluetooth": "af74",
	"./sensor-bluetooth.json": "af74",
	"./sensor-disconnect": "31b1",
	"./sensor-disconnect.json": "31b1",
	"./sensor-error": "bf68",
	"./sensor-error.json": "bf68",
	"./sensor.json": "844f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfe3";